export default __webpack_public_path__ + "static/backgroundHero-d2a77b218e8150d95a672c0c94c423bb.jpeg";